import React from "react";

const CustomerRulesAndRegulations = (props) => {
  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h3 className="title_text text-dark">
                  Topcoin rules and regulations
                </h3>

                <p className="info_description text-dark opacity-75 mb-3">
                  To maintain a fair, transparent, and active TopCoin UK system,
                  all customers must comply with the following policy terms.
                </p>
                <strong>
                  <ol className="text-dark opacity-75 ">
                    <li className="mt-2 ">
                      Milestone Requirement
                      <p className="info_description text-dark opacity-75 mt-2">
                        Each customer must achieve the second milestone level of
                        20,000 TopCoin within 3 years from the date of account
                        activation.
                      </p>
                    </li>

                    <li className="mt-2">
                      Failure to Meet the Milestone
                      <p className="info_description text-dark opacity-75 mt-2">
                        If a customer does not meet this milestone within the
                        required period, their account may be reviewed and may
                        be restricted or closed in accordance with TopCoin UK
                        Ltd policy.
                      </p>
                      <p className="info_description text-dark opacity-75 mt-2">
                        Any unused, unallocated, or forfeited TopCoins may be
                        reassigned within the system in line with company
                        policy.
                      </p>
                    </li>

                    <li className="mt-2">
                      Account Closure
                      <p className="info_description text-dark opacity-75 mt-2">
                        If an account is closed under this policy, a new account
                        may not be opened using the same personal details or
                        identification information, subject to TopCoin UK Ltd
                        verification procedures and applicable law.
                      </p>
                    </li>

                    <li className="mt-2">
                      Limited Allocation
                      <p className="info_description text-dark opacity-75 mt-2">
                        A total of 30,000,000 TopCoins is allocated to customers
                        in England, Scotland, and Wales.
                      </p>
                      <p className="info_description text-dark opacity-75 mt-2">
                        Within the TopCoin UK system, this also represents the
                        maximum number of customer sign-ins permitted under this
                        release, with each eligible customer account treated as
                        one TopCoin sign-in.
                      </p>
                      <p className="info_description text-dark opacity-75 mt-2">
                        Once the full allocation of 30,000,000 customer sign-ins
                        has been reached, no further entries will be accepted
                        unless a new allocation or release is formally announced
                        by TopCoin UK Ltd.
                      </p>
                    </li>
                  </ol>
                </strong>
                <strong>
                  <ol className="text-dark opacity-75" start="5">
                    <li className="mt-2">
                      Future Regional Allocations
                      <p className="info_description text-dark opacity-75 mt-2">
                        Additional TopCoin allocations for other countries or
                        regions may be introduced in future phases. Any such
                        allocation will be announced by TopCoin UK Ltd at the
                        time of release.
                      </p>
                    </li>
                    <li className="mt-2">Purpose of This Policy</li>

                    <p className="info_description text-dark opacity-75 mb-0">
                      This policy is intended to:
                      <strong>
                        <ul className="text-dark opacity-75">
                          <li className="mt-2">
                            encourage active participation
                          </li>
                          <li className="mt-2">reduce inactive accounts</li>
                          <li className="mt-2">
                            support fair allocation within the system
                          </li>
                          <li className="mt-2">
                            maintain stability and orderly growth across the
                            network
                          </li>
                        </ul>
                      </strong>
                    </p>
                  </ol>
                </strong>

                <br />
                <strong>
                  <ol className="text-dark opacity-75" start="7">
                    <li className="mt-2">
                      Verification and Enforcement
                      <p className="info_description text-dark opacity-75 mt-2">
                        TopCoin UK Ltd reserves the right to review, verify, and
                        enforce compliance with this policy, and to take any
                        action considered necessary in accordance with company
                        procedures and applicable law.
                      </p>
                    </li>
                  </ol>
                </strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerRulesAndRegulations;
